<template>
  <div class="mergeIssuePrint">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="生产发料详情"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="model"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div style="white-space: pre-wrap">{{model.productionOrders}}</div>
        <div v-if="!isPrint">
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            发料明细
          </div>
          <el-table
              :data="productionOrderList"
              border
              style="width: 100%">
            <el-table-column prop="materialNo" align="center" label="物料号" width="90"/>
            <el-table-column prop="materialName" align="center" label="物料描述"/>
            <el-table-column prop="location" align="center" label="存储地点" width="80"/>
            <el-table-column prop="locationNo" align="center" label="库存仓位" width="80"/>
            <el-table-column prop="locationSumQty" align="center" label="工厂库存" width="80"/>
            <el-table-column prop="sumQty" align="center" label="发料数量" width="110">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.sumQty"
                    clearable/>
              </template>
            </el-table-column>
            <el-table-column prop="billNo1" align="center" :label="billNo1" width="90"/>
            <el-table-column prop="billNo2" align="center" :label="billNo2" width="90"/>
            <el-table-column prop="billNo3" align="center" :label="billNo3" width="90"/>
            <el-table-column prop="billNo4" align="center" :label="billNo4" width="90"/>
            <el-table-column prop="billNo5" align="center" :label="billNo5" width="90"/>
          </el-table>
        </div>
        <div v-else id="print">
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            发料明细
          </div>
          <el-table
              :data="productionOrderList"
              border
              style="width: 100%">
            <el-table-column prop="materialNo" align="center" label="物料号" width="90"/>
            <el-table-column prop="materialName" align="center" label="物料描述"/>
            <el-table-column prop="location" align="center" label="库存地址" width="80"/>
            <el-table-column prop="locationSumQty" align="center" label="工厂库存" width="80"/>
            <el-table-column prop="sumQty" align="center" label="发料数量" width="110"/>
            <el-table-column prop="billNo1" align="center" :label="billNo1" width="90"/>
            <el-table-column prop="billNo2" align="center" :label="billNo2" width="90"/>
            <el-table-column prop="billNo3" align="center" :label="billNo3" width="90"/>
            <el-table-column prop="billNo4" align="center" :label="billNo4" width="90"/>
            <el-table-column prop="billNo5" align="center" :label="billNo5" width="90"/>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <template>
          <el-button
              type="primary"
              :loading="saveLoading"
              @click="printHandle">打印</el-button>
        </template>
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import LoginUtil from "@/util/loginUtil";

  export default {
    name: "MergeIssuePrint",
    components: {},
    data() {
      return {
        isPrint: false,
        uploadAuth: this.$auth(454),
        constant,
        uploadLoading: false,
        userType: LoginUtil.getUserType(),
        dialogVisible: false,
        contentLoading: false,
        saveLoading: false,
        submitLoading: false,
        submitDisable: true,
        tableData: [],
        productionOrderList: [],
        receiveStatus: "",
        billNo1: "",
        billNo2: "",
        billNo3: "",
        billNo4: "",
        billNo5: "",
        activeName: "first",
        files: [],
        model: {
          billNo: "",
          productionOrders: "",
        },
        ruleValidate: {},
      };
    },
    methods: {
      open(row,note) {
        this.model.productionOrders = note;
        this.dialogVisible = true;
        if (row.length > 0) {
          this.getData(row);
        }
      },
      getData(orderNoList) {
        console.log(orderNoList);
        this.$http.post("basic", "sapProductionOrders/createMergeOrder", orderNoList).then((resp) => {
          console.log(resp.data);
          let item = resp.data[0];
          this.productionOrderList = JSON.parse(JSON.stringify(resp.data));
          if (item.billNo1) {
            this.billNo1 = item.billNo1;
          }
          if (item.billNo2) {
            this.billNo2 = item.billNo2;
          }
          if (item.billNo3) {
            this.billNo3 = item.billNo3;
          }
          if (item.billNo4) {
            this.billNo4 = item.billNo4;
          }
          if (item.billNo5) {
            this.billNo5 = item.billNo5;
          }
          this.productionOrderList.splice(0, 1);
        });
      },
      printHandle() {
        this.$nextTick(function() {
          this.isPrint = true;
          document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
          window.print();
          window.location.reload();
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.mergeIssuePrint {
  .el-form-item__content {
    margin-left: 2% !important;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #EBEEF5;
    border-bottom: none;
    border-left: none;
    margin-bottom: 15px;
  }

  table.gridtable tr td {
    padding: 8px;
    border-left: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

}

</style>
